<!-- 申请人信息 -->
<template>
  <div class="form-common">
    <div v-for="(item, index) in list" :key="index" class="appinfo-box">
      <div class="typeTitle">
        <div class="typeTitle-name">{{item.applicantCategory == '1' ? '个人' : '法人'}}</div>
        <div
          v-show="index && opera == 0 "
          @click="delItem(item, index)"
          class="el-icon-remove re-btn-del"
        />
      </div>
      <el-form
        :model="item"
        :disabled="opera == 2"
        :rules="applicantRules"
        :ref="'applicant' + index"
        class="search-form search-items"
        label-position="top"
      >
        <el-form-item v-if="item.applicantCategory == '1'" label="姓名" prop="applicantName">
          <el-input
            :disabled="index == 0 || opera != '0' "
            v-model.trim="item.applicantName"
            class="search-input"
            maxlength="20"
          />
        </el-form-item>
        <el-form-item v-if="item.applicantCategory == '2'" label="组织名称" prop="applicantName">
          <el-input
            :disabled="opera != '0' "
            v-model.trim="item.applicantName"
            class="search-input"
            maxlength="20"
          />
        </el-form-item>
        <el-form-item
          v-if="item.applicantCategory == '2'"
          label-width="140px"
          prop="socialUnifiedCreditCode"
          class="xydm"
        >
          <div slot="label">
            社会信用代码
            <el-tooltip class="item" effect="light" content="应填写统一社会信用代码，非证照编号。" placement="bottom">
              <i class="el-icon-warning" style="color:#cbb486"></i>
            </el-tooltip>
          </div>
          <el-input
            v-model.trim="item.socialUnifiedCreditCode"
            class="search-input"
            maxlength="20"
          />
        </el-form-item>
        <el-form-item
          label="证件类型"
          v-if="item.applicantCategory == '1'"
          :rules="[ { required: opera == 0 || opera == 1,validator: (rule, value, callback) => checkidentificationType(rule, value, callback, item), trigger: 'change' } ,]"
          prop="identificationType"
        >
          <el-select
            disabled
            v-model="item.identificationType"
            @change="val => { changeIdType(val, item, index)}"
            placeholder="请选择"
            class="search-input"
          >
            <el-option v-for="it in optionIDType" :key="it.code" :label="it.name" :value="it.code" />
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="item.applicantCategory == '1'"
          :rules="[ { required: true,validator: (rule, value, callback) => checkidentificationCard(rule, value, callback, item), trigger: 'blur' } ,]"
          label="证件号码"
          prop="identificationCard"
        >
          <el-input
            :disabled="index == 0 || opera != '0' "
            v-model.trim="item.identificationCard"
            @change="val => cardChange(val,index)"
            class="search-input"
            maxlength="20"
          />
        </el-form-item>
        <el-form-item
          prop="fileListJpgfR"
          label-width="220px"
          v-if="item.applicantCategory == '2'"
          class="upload-identificationFile"
        >
          <span slot="label">
            营业执照或其他证件材料
            <el-tooltip class="item" effect="light" content="法人或其他组织的营业执照等证明材料。" placement="bottom">
              <i class="el-icon-warning" style="color:#cbb486"></i>
            </el-tooltip>
          </span>
          <el-upload
            :disabled="opera != '0' "
            class="upload-identiFile"
            :class="{ 'have': item.fileListJpgfR.length > 0 }"
            action
            list-type="picture-card"
            :http-request="param => handleUpload(param , 0, item)"
            :data="{item}"
            :before-upload="(param)=>beforeUpload(param, item, 0)"
            :on-remove="file => handleRemove(file, 'fileListJpgfR')"
            :on-preview="handlePictureCardPreview"
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="item.fileListJpgfR"
            accept=".jpg, .jpeg, .png"
          >
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span
                  class="el-upload-list__item-delete"
                  @click="handleRemove(file, 'fileListJpgfR')"
                >
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item
          label="法人代表人名称"
          label-width="150px"
          v-if="item.applicantCategory == '2'"
          prop="legalRepresentative"
        >
          <el-input v-model.trim="item.legalRepresentative" class="search-input" maxlength="20" />
        </el-form-item>

        <el-form-item label="联系人" v-if="item.applicantCategory == '2'" prop="contactName">
          <el-input
            v-model.trim="item.contactName"
            :disabled="!index"
            class="search-input"
            maxlength="20"
          />
        </el-form-item>
        <el-form-item
          label-width="150px"
          v-if="item.applicantCategory == '2'"
          :rules="[ { required: opera == 0 || opera == 1,validator: (rule, value, callback) => checkidentificationCard(rule, value, callback, item), trigger: 'blur' } ,]"
          label="联系人证件号码"
          prop="identificationCard"
        >
          <el-input
            :disabled="!index"
            v-model.trim="item.identificationCard"
            @change="val => cardChange(val,index)"
            class="search-input"
            maxlength="20"
          />
        </el-form-item>

        <el-form-item prop="fileListJpg2" class="upload-identificationFile">
          <span slot="label">身份证人像面</span>
          <el-upload
            class="upload-identiFile"
            :class="{ 'have': item.fileListJpg2.length > 0 }"
            :disabled=" opera != '0' && index == 0 "
            action
            list-type="picture-card"
            :http-request="param => handleUpload(param , 4,item)"
            :on-preview="handlePictureCardPreview"
            :data="{item}"
            :before-upload="(param)=>beforeUpload(param, item)"
            :on-remove="file => handleRemove(file, 'fileListJpg2')"
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="item.fileListJpg2"
            accept=".jpg, .jpeg, .png"
          >
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span
                  class="el-upload-list__item-delete"
                  v-if="index > 0"
                  @click="handleRemove(file, 'fileListJpg2')"
                >
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item prop="fileListJpg" class="upload-identificationFile">
          <span slot="label">身份证国徽面</span>
          <el-upload
            class="upload-identiFile"
             :class="{ 'have': item.fileListJpg.length > 0 }"
            :disabled=" opera != '0' && index == 0 "
            action
            list-type="picture-card"
            :http-request="param => handleUpload(param , 3,item)"
            :data="{item}"
            :before-upload="(param)=>beforeUpload(param, item)"
            :on-remove="file => handleRemove(file, 'fileListJpg')"
            :limit="1"
            :on-preview="handlePictureCardPreview"
            :on-exceed="handleExceed"
            :file-list="item.fileListJpg"
            accept=".jpg, .jpeg, .png"
          >
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span
                  class="el-upload-list__item-delete"
                  v-if="index > 0"
                  @click="handleRemove(file, 'fileListJpg')"
                >
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="性别" v-if="item.applicantCategory == '1'" prop="gender">
          <el-select
            v-model="item.gender"
            :disabled="!index || item.identificationType == '1001001'"
            placeholder="请选择"
            class="search-input"
          >
            <el-option
              v-for="it in optionSexType"
              :key="it.lable"
              :label="it.value"
              :value="it.lable"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="国家" v-if="item.applicantCategory == '1'" prop="country">
          <el-select
            :disabled="!index || item.identificationType == '1001001'"
            v-model="item.country"
            placeholder="请选择"
            class="search-input"
          >
            <el-option
              v-for="at in optionCountry"
              :key="at.code"
              :label="at.name"
              :value="at.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="出生日期" v-if="item.applicantCategory == '1'" prop="birthday">
          <el-date-picker
            v-model="item.birthday"
            type="date"
            placeholder="选择日期"
            class="search-input"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            :clearable="false"
            :disabled="item.isbornDate || !index"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input
            v-model.trim="item.phone"
            :disabled="!index"
            class="search-input"
            maxlength="20"
          />
        </el-form-item>
        <el-row>
          <el-col :lg="16" :md="16" :xs="24" style="margin-bottom: 16px">
            <el-form-item prop="deliveryArea" label-width="150px" class="xydm mobileArea">
              <div slot="label">
                文书送达地址
                <el-tooltip
                  class="item"
                  effect="light"
                  content="文书送达地址系申请人接收行政复议法律文书的邮寄地址，请确认上述送达地址是准确的、有效的，因送达地址不准确导致行政复议法律文书未能被实际接收的，法律后果由申请人承担。"
                  placement="bottom"
                >
                  <i class="el-icon-warning" style="color:#cbb486"></i>
                </el-tooltip>
              </div>
              <el-input class="mobileArea" placeholder="点击选择省市区"  @focus="showArea(index)" v-model="item.deliveryArea" readonly></el-input>
            </el-form-item>
            <el-form-item prop="deliveryArea" label-width="150px" class="xydm pcArea">
              <div slot="label">
                文书送达地址
                <el-tooltip
                  class="item"
                  effect="light"
                  content="文书送达地址系申请人接收行政复议法律文书的邮寄地址，请确认上述送达地址是准确的、有效的，因送达地址不准确导致行政复议法律文书未能被实际接收的，法律后果由申请人承担。"
                  placement="bottom"
                >
                  <i class="el-icon-warning" style="color:#cbb486"></i>
                </el-tooltip>
              </div>
              <el-cascader
                style="width: 100%"
                size="large"
                :options="pcaTextArr"
                v-model="item.deliveryArea"
              ></el-cascader>
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="8" :xs="24">
            <el-form-item prop="addr" label-width="10px">
              <el-input
                v-model.trim="item.addr"
                placeholder="请填写具体路名，门牌号"
                class="search-input"
                maxlength="100"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-dialog :visible.sync="dialogVisible" append-to-body>
        <img width="100%" :src="dialogImageUrl" alt />
      </el-dialog>

      <!-- 手机端省市区选择弹出框 -->
      <van-popup v-model="areaVis" round position="bottom" :style="{ height: '40%' }">
        <van-area title="省市区" :area-list="areaList" :value="areaValue" @cancel="cancel" @confirm="confirm" />
      </van-popup>
    </div>
  </div>
</template>

<script>
import Api from '@api/api'
import { pcaTextArr } from 'element-china-area-data'
import { areaList } from '@/utils/area.js'
import { ImagePreview } from 'vant'
import { ocrIdCardCheck, uuid, isEmojiCharacter } from '@/utils'
let fileloading = null
export default {
  props: {
    opera: {
      type: Number,
      required: 0
    },
    applicantInfoList: {
      default: () => {
        return []
      },
      type: Array,
      required: true
    },
    caseOrderNo: {
      type: String,
      required: true
    }
  },
  data () {
    // 定义校验规则
    var validatePhone = (rule, value, callback) => {
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }
    var validateAddr = (rule, value, callback) => {
      if (!value || !value.trim()) {
        if (rule.required) {
          callback(new Error('请填写具体路名，门牌号'))
        } else {
          callback()
        }
      } else {
        const chineseChars = value.match(/[\u4e00-\u9fa5]/g)
        if (!chineseChars || chineseChars.length < 4) {
          callback(new Error('至少需要包含4个汉字'))
        } else {
          callback()
        }
      }
    }
    var validateApplicantName = (rule, value, callback) => {
      if (
        (/^(?:[\u4e00-\u9fa5·]{0,20})$/.test(value) ||
          /(^[a-zA-Z][a-zA-Z\s]{0,20}[a-zA-Z]$)/.test(value)) &&
        value !== ''
      ) {
        callback()
      } else {
        callback(new Error('请输入正确的名称'))
      }
    }
    return {
      list: [],
      areaVis: false,
      index: 0,
      areaValue: '310101',
      pcaTextArr,
      areaList,
      dialogVisible: false,
      dialogImageUrl: '',
      optionIDType: [],
      optionCountry: [],
      optionSexType: [
        {
          value: '女',
          lable: '0'
        },
        {
          value: '男',
          lable: '1'
        }
      ],
      applicantRules: {
        fileListJpg2: [
          {
            required: this.opera == 0,
            validator: this.validateFileUrl,
            trigger: ['change', 'blur']
          }
        ],
        fileListJpg: [
          {
            required: this.opera == 0,
            validator: this.validateFileUrl,
            trigger: ['change', 'blur']
          }
        ],
        fileListJpgfR: [
          {
            required: this.opera == 0 || this.opera == 1,
            validator: this.validateFileUrl,
            trigger: 'change'
          }
        ],

        applicantName: [
          {
            required: this.opera == 0 || this.opera == 1,
            message: '请输入正确的名称',
            trigger: 'blur'
          }
        ],
        socialUnifiedCreditCode: [
          {
            required: this.opera == 0 || this.opera == 1,
            message: '请输入社会信用代码',
            trigger: 'blur'
          }
        ],
        gender: [
          {
            required: this.opera == 0 || this.opera == 1,
            message: '请选择性别',
            trigger: 'change'
          }
        ],
        contactName: [
          {
            required: this.opera == 0 || this.opera == 1,
            message: '请输入正确的联系人',
            trigger: 'blur'
          }
        ],
        country: [
          {
            required: this.opera == 0 || this.opera == 1,
            message: '请选择国家',
            trigger: 'change'
          }
        ],
        deliveryArea: [
          {
            required: this.opera == 0,
            message: '请选择文书送达区域',
            trigger: 'change'
          }
        ],
        birthday: [
          {
            required: this.opera == 0 || this.opera == 1,
            message: '请选择出生日期',
            trigger: 'change'
          }
        ],
        phone: [
          {
            required: this.opera == 0 || this.opera == 1,
            validator: validatePhone,
            trigger: 'blur'
          }
        ],
        addr: [
          {
            required: this.opera == 0 || this.opera == 1,
            validator: validateAddr,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    applicantInfoList (newVal) {
      this.list = newVal
    }
  },
  created () {
    this.listDictByParentCodes()
  },
  mounted () {
    this.list = this.applicantInfoList
  },
  methods: {

    // 省市区选择
    cancel () {
      this.areaVis = false
    },
    confirm (val) {
      console.log(val)
      const arra = []
      val.forEach(item => {
        arra.push(item.name)
      })
      this.list[this.index].deliveryArea = arra
      this.areaVis = false
    },
    // 打开省市区选择
    showArea (index) {
      this.index = index
      this.areaVis = true
    },
    // 证件号码校验
    cardChange (val, index) {
      const findex = this.applicantInfoList.findIndex(
        item => item.identificationCard == val
      )
      if (findex != -1 && findex != index) {
        this.$toast('多位申请人证件号码不能重复')
        this.applicantInfoList[index].identificationCard = ''
      }
    },
    handlePictureCardPreview (file) {
      console.log(file)
      ImagePreview({
        images: [file.url],
        closeable: true
      })
      // this.dialogImageUrl =
      //   file.originPath ||
      //   file.showPath.includes("https://landing.iflysec.com:443")
      //     ? file.showPath.replace(
      //         "https://landing.iflysec.com:443",
      //         "http://172.31.243.74:88"
      //       )
      //     : file.showPath;
      // this.dialogVisible = true;
    },
    validateFileUrl (rule, value, callback) {
      if (!rule.required) {
        callback()
        return
      }
      if (value.length === 0) {
        callback(new Error('请上传⽂件'))
      } else {
        callback()
      }
    },
    // 证件号码校验
    checkidentificationCard (rule, value, callback, itemList) {
      if (itemList.identificationCard === '') {
        return callback(new Error('请输入证件号码'))
      } else if (itemList.identificationType === '1001001') {
        // 证件类型为身份证时
        if (
          /^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/.test(
            itemList.identificationCard
          )
        ) {
          // 获取出身日期
          itemList.birthday = itemList.identificationCard
            .substr(6, 8)
            .replace(/(.{4})(.{2})/, '$1-$2-')
          // 获取性别
          itemList.gender = this.getGenderInfo(
            itemList.identificationCard
          ).gender
          itemList.isbornDate = true
          callback()
        } else {
          return callback(new Error('证件号码格式错误'))
        }
      } else {
        itemList.isbornDate = false
        callback()
      }
    },
    // 证件类型
    checkidentificationType (rule, value, callback, itemList) {
      if (itemList.identificationType === '') {
        return callback(new Error('请选择证件类型'))
      } else if (
        itemList.identificationType === '1001001' &&
        itemList.identificationCard !== ''
      ) {
        // 证件类型为身份证时
        if (
          /^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/.test(
            itemList.identificationCard
          )
        ) {
          // 获取出身日期
          itemList.birthday = itemList.identificationCard
            .substr(6, 8)
            .replace(/(.{4})(.{2})/, '$1-$2-')
          itemList.gender = this.getGenderInfo(
            itemList.identificationCard
          ).gender
          itemList.isbornDate = true
          callback()
          // } else {
          //   return callback(new Error('证件号码格式错误'))
        }
      } else {
        itemList.isbornDate = false
        if (itemList.identificationType === '1001001') {
          itemList.country = '1000001'
        }
        callback()
      }
    },
    // 根据身份证号分辨男女
    getGenderInfo (number) {
      const flag = number[16]
      if (flag % 2) {
        return {
          gender: '1',
          name: '男'
        }
      }
      return {
        gender: '0',
        name: '女'
      }
    },
    // 增加一个申请人
    addItem (item) {
      if (this.list.length === 0) {
        const currentApplientInfo = localStorage.getItem('applicantInfo')
          ? JSON.parse(localStorage.getItem('applicantInfo'))
          : {}
        item.id = this.$route.query.identificationApplicant
        item.phone = currentApplientInfo.phone
        item.fileListJpg = currentApplientInfo.fileListJpg
        item.fileListJpg2 = currentApplientInfo.fileListJpg2
        item.identificationCard = currentApplientInfo.identificationCard

        item.isidType = true // 收个证件类型不能更改
        if (currentApplientInfo.identificationType == '1001001') {
          // 类型为身份证类型则不能修改
          this.isbornDate = true
        }
        if (item.applicantCategory == '1') {
          const { gender, name } = this.getGenderInfo(item.identificationCard)
          item.genderName = name
          item.gender = gender
          item.country = '1000001'
          item.countryName = '中国'
          item.identificationType = '1001001'
          item.applicantName = currentApplientInfo.loginName
          item.birthday = item.identificationCard
            .substr(6, 8)
            .replace(/(.{4})(.{2})/, '$1-$2-')
        } else {
          item.contactName = currentApplientInfo.loginName
        }
      }
      item.identificationType = '1001001'
      item.country = '1000001'
      item.countryName = '中国'
      this.list.push(item)
    },
    // 删除一个申请人
    delItem (item, index) {
      this.list.splice(index, 1)
    },
    // 证件类型change事件
    changeIdType (val, item, index) {
      item.identificationCard = ''
    },
    // 申请人姓名 失焦
    // 身份证证件号码失焦
    // 判断用户姓名和身份证号是否匹配人口库
    async compUsers (item) {
      if (item.applicantCategory === '1') {
        if (
          item.applicantName &&
          item.identificationType === '1001001' &&
          item.identificationCard
        ) {
          const param = [
            {
              name: item.applicantName,
              id: item.identificationCard
            }
          ]
          await this.checkUsers(param)
        }
      } else if (item.applicantCategory === '2') {
        if (
          item.legalRepresentative &&
          item.identificationType === '1001001' &&
          item.identificationCard
        ) {
          const param = [
            {
              name: item.legalRepresentative,
              id: item.identificationCard
            }
          ]
          await this.checkUsers(param)
        }
      }
    },
    async checkUsers (param) {
      let res = await Api.checkUsers(param)
      res = res?.data?.data
      if (!res.code && res.result.length) {
        const str = res.result.join('、')
        this.$toast(str)
        return str
      } else {
        return ''
      }
    },
    // 文件上传
    // 上传文件之前的钩子
    beforeUpload (file, item, kindType) {
      console.log(item)
      if (kindType != 0) {
        if (!item.identificationCard) {
          this.$toast({
            message: '请先输入身份证号！'
          })
          return false
        }

        if (item.applicantCategory == 1) {
          if (!item.applicantName) {
            console.log(item)
            this.$toast({
              message: '请先输入真实姓名！'
            })
            return false
          }
        } else {
          if (!item.contactName) {
            console.log(item)
            this.$toast({
              message: '请先输入真实姓名！',
              type: 'warning',
              center: true
            })
            return false
          }
        }
      }

      const isLt20MB = file.size / 1024 / 1024 < 20
      const a = file.name
      const b = ['.jpg', '.jpeg', '.png']
      const isType = b.includes(a.slice(a.lastIndexOf('.')).toLowerCase())
      if (!isLt20MB) {
        if (document.getElementsByClassName('el-message').length > 0) {
          return false
        }
        this.$toast({
          message: '上传文件大小不能超过 20MB!',
          type: 'warning',
          center: true
        })
        return false
      }
      if (!isType) {
        if (document.getElementsByClassName('el-message').length > 0) {
          return false
        }
        this.$toast({
          message: '上传文件格式必须为jpg、jpeg、png',
          type: 'warning',
          center: true
        })
        return false
      }
    },
    // 限制文件上传个数
    handleExceed (files, fileList) {
      this.$toast('当前限制选择 1 个文件')
    },
    // 自定义上传
    handleUpload (param, kindType, item) {
      fileloading = this.$loading({
        lock: true,
        text: kindType == 0 ? '营业执照证件材料校验中' : '身份证校验中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      if (kindType == '4') {
        ocrIdCardCheck(
          param.file,
          item.applicantCategory == 1 ? item.applicantName : item.contactName,
          item.identificationCard,
          null,
          res => {
            if (res.data.data) {
              this.uploadHandle(param, kindType, item)
            } else {
              item.fileListJpg2 = []
              this.$toast(
                '请确认您的证件图片为本人原件保持姓名与身份证号清晰且无破损'
              )
              fileloading.close()
            }
          }
        )
      } else if (kindType == '3') {
        ocrIdCardCheck(
          param.file,
          item.applicantName,
          item.identificationCard,
          1,
          res => {
            if (res.data.data) {
              this.uploadHandle(param, kindType, item)
            } else {
              fileloading.close()
              item.fileListJpg = []
              this.$toast('请确认您的证件图片保持国徽清晰且无破损')
            }
          }
        )
      } else {
        this.uploadHandle(param, kindType, item)
      }
    },
    uploadHandle (param, kindType, item) {
      const formData = new FormData()
      formData.append('caseOrderNo', this.caseOrderNo)
      formData.append('evidenceName', param.file.name)
      formData.append('evidence', param.file)
      formData.append('file', param.file)
      formData.append('kindType', kindType) // 证据材料类型（0证件照1具体行政行为材料2其他补充材料 3 身份证反面 4身份证正面）
      formData.append('identificationApplicant', item.id)
      Api.appletsUpload(formData)
        .then(({ data }) => {
          const fileListJpg = []
          const resData = data.data
          resData.showPath = resData.showPath.replace(
            'landing.iflysec.com:80',
            'landing.iflysec.com'
          )
          const Url = window.g.fileUrl + data.data.evidencePath
          fileListJpg.push({
            ...resData,
            url: Url,
            name: param.file.name,
            thumb: resData.showPath,
            type: param.file.type
          })
          if (kindType == '3') {
            item.fileListJpg = fileListJpg
          } else if (kindType == '0') {
            item.fileListJpgfR = fileListJpg
          } else {
            item.fileListJpg2 = fileListJpg
          }
          console.log(item)
          fileloading.close()
        })
        .catch(() => {
          fileloading.close()
        })
    },
    // 删除文件
    handleRemove (file, fileName) {
      if (file.id) {
        Api.deleteFileById(file.id).then(res => {
          this.list.forEach((item, index) => {
            if (item[fileName][0] && item[fileName][0].id === file.id) {
              item[fileName].forEach((ite, index) => {
                if (ite.id === file.id) {
                  item[fileName].splice(index, 1)
                  const formName = 'applicant' + index
                  if (this.$refs[formName]) {
                    this.$refs[formName][0].validateField(fileName)
                  }
                }
              })
            }
            const formName = 'applicant' + index
            if (this.$refs[formName]) {
              this.$refs[formName][0].validateField(fileName)
            }
          })
        })
      }
    },
    // 获取类型
    listDictByParentCodes () {
      // 证件类型
      Api.listDictByParentCodes({ parentCodes: '1000,1001' }).then(res => {
        this.optionCountry = res.data.data[0].subDictList
        this.optionIDType = res.data.data[1].subDictList
        console.log(this.optionIDType)
      })
    },
    // 校验
    checkAll () {
      return new Promise((resolve, reject) => {
        let checkPass = true
        let isEmoji = false
        this.list.map((item, index) => {
          const formName = 'applicant' + index
          this.$refs[formName][0].validate(valid => {
            console.log(valid)
            if (valid) {
              console.log('submit!', formName)
              for (const validKey in item) {
                console.log(isEmojiCharacter(item[validKey]))
                if (isEmojiCharacter(item[validKey])) {
                  isEmoji = true
                }
              }
            } else {
              checkPass = false
            }
          })
        })
        if (checkPass) {
          if (isEmoji) {
            reject(
              this.$toast(
                '申请人信息中含有表情符号，请去掉文字内嵌入的图片'
              )
            )
          } else {
            resolve()
          }
        } else {
          reject(this.$toast('请检查申请人信息'))
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.xydm {
  ::v-deep .el-form-item__label {
    display: flex;
  }
}
.form-common {
  .appinfo-box {
    background: rgba(90, 137, 253, 0.02);
    padding-bottom: 20px;
    box-shadow: 2px 6px 10px 0px rgba(128, 126, 189, 0.24);
    border-radius: 0px 0px 4px 4px;
    backdrop-filter: blur(20px);
    margin-top: 24px;
    margin-bottom: 24px;
    .typeTitle {
      width: 100%;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px;
      .typeTitle-name {
        font-size: 16px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: #333333;
        line-height: 24px;
      }
      .re-btn-del {
        color: #fe3535;
        font-size: 18px;
        line-height: 39px;
        cursor: pointer;
      }
    }
    .search-form {
      display: flex;
      align-items: center;
      padding: 0 16px;
      justify-content: flex-start;
    }
  }
  ::v-deep .el-upload-list--picture-card .el-upload-list__item {
    width: 100%;
    height: 180px;
    position: relative !important;
    overflow: hidden !important;
  }

  // 修复图片显示问题：让图片铺满容器
  ::v-deep .el-upload-list__item-thumbnail {
    // object-fit: cover !important;
    width: 100% !important;
    height: 100% !important;
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
  }

  ::v-deep .el-upload--picture-card {
     width: 100%;
  }
   ::v-deep .have .el-upload--picture-card {
    display: none!important;
  }
  // 证据材料图片
  .upload-identificationFile {
    .upload-identiFile {
      display: flex;
      border-radius: 3px;
      width: 100%;
      align-items: center;
      .identiFile-btn {
        background-color: #5a9cff;
        height: 24px;
        width: 100%;
        line-height: 23px;
        color: white;
        border-radius: 3px;
        font-size: 12px;
        margin-left: 3px;
      }
      ::v-deep .el-upload-list {
        margin-left: 5px;
        width: 70%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      ::v-deep .el-upload-list__item:first-child {
        margin-top: 0px;
      }
      ::v-deep .el-upload--text {
        width: 100%;
      }
    }
  }
}

@media screen and (min-width: 1000px) {
  .mobileArea {
    display: none;
  }
  .pcArea {
    display: block;
  }
}

@media screen and (max-width: 1000px) {
  .mobileArea {
    display: block;
  }
  .pcArea {
    display: none;
  }
  .appinfo-box {
    .col1-3 {
      width: 100%;
    }
  }
  .upload-identiFile {
    min-height: 70px !important;
    display: block !important;
  }
  .identiFile-btn {
    width: 50% !important;
  }
}
@media screen and (max-width: 600px) {
  .main-contentBox {
    .appinfo-box {
      ::v-deep.el-form-item__label {
        width: 100% !important;
        font-size: 12px !important;
        padding-bottom: 0;
      }
      ::v-deep.el-form-item__content {
        width: 100% !important;
      }
    }
  }
}

@media screen and (max-width: 450px) {
  .appinfo-box {
    .col1-3 {
      width: 100%;
    }
    .el-form-item {
      width: 100%;
      margin-bottom: 0;
    }
    ::v-deep .el-form-item__error {
      position: static;
    }
  }
}
</style>
